import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useSiteSettings } from "@/hooks/usePortfolio";
import { getImageUrl } from "@/api/client";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { BackToTop } from "@/components/BackToTop";
import { SocialLinks } from "@/components/SocialLinks";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import BlogDetail from "@/pages/BlogDetail";
import CertificationsPage from "@/pages/CertificationsPage";

function SiteMetadata() {
  const { data: siteSettings } = useSiteSettings();

  useEffect(() => {
    if (siteSettings?.faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = getImageUrl(siteSettings.faviconUrl);
    }
  }, [siteSettings]);

  return null;
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App relative">
          <SiteMetadata />
          <Navbar />
          <SocialLinks variant="floating" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/certifications" element={<CertificationsPage />} />
          </Routes>
          <Footer />
          <BackToTop />
          <WhatsAppFloat />
          <Toaster position="bottom-right" theme="dark" richColors closeButton />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
